import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import classnames from 'classnames';
import UserMenuAvatar from './../../../_partials/UserMenu/UserMenuMobile/_partials/UserMenuAvatar';
import UserMenuMobile from '../../../_partials/UserMenu/UserMenuMobile';
import { UserMenuContext, UserMenuContextProvider } from '../../../_partials/UserMenu/UserMenuMobile/UserMenuContext';
import { useIosHeightHack } from './useIosHeightHack';
import s from './UserMenuButton.scss';
const UserMenuButton = (_param)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const { isSliding, isOpen: isUserMenuOpen, toggleUserMenu, setScrollableRef } = useContext(UserMenuContext);
    const { isIosHeightHackNeeded, setRootRef } = useIosHeightHack();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['user-menu-wrapper'], isSliding && s['sliding'], className)
    }, !isUserMenuOpen && /*#__PURE__*/ React.createElement("span", {
        className: s['avatar-wrapper']
    }, /*#__PURE__*/ React.createElement(UserMenuAvatar, null)), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['user-menu-shade'], isUserMenuOpen && s['is-active']),
        // Since react-onclickoutside wasn't really working for this component and my most
        // valiant efforts to make it do so were met with failure, just do it ourselves
        onTouchStart: toggleUserMenu,
        onClick: toggleUserMenu,
        "aria-hidden": !isUserMenuOpen
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['user-menu-list-wrapper'], isUserMenuOpen && s['is-opened'], isIosHeightHackNeeded && s['ios-sucks']),
        ref: (node)=>{
            setScrollableRef(node);
            setRootRef(node);
        },
        "aria-hidden": !isUserMenuOpen
    }, /*#__PURE__*/ React.createElement(UserMenuMobile, props)));
};
UserMenuButton.displayName = 'UserMenu';
const UserMenuButtonWithContextWrapper = (props)=>{
    return /*#__PURE__*/ React.createElement(UserMenuContextProvider, null, /*#__PURE__*/ React.createElement(UserMenuButton, props));
};
UserMenuButtonWithContextWrapper.displayName = 'UserMenuButtonWithContextWrapper';
export default UserMenuButtonWithContextWrapper;
